import {currencyFormatter, USPhoneNumberFormat} from './../services/Utils';
import FormConstants from '../constants/FormConstants';
import DateUtils from './DateTimeUtils';

// import jwt from 'jsonwebtoken';

import {SignJWT} from 'jose';

type FormattableValue = string | number | undefined | boolean | null;

const formatBooleanValue = (value: any): string => {
  if (typeof value === 'string') {
    const normalizedValue = value.trim().toLowerCase();

    if (
      normalizedValue === 'yes' ||
      normalizedValue === 'true' ||
      normalizedValue === '1'
    ) {
      return FormConstants.BOOLEAN_TYPES.YES;
    }

    if (
      normalizedValue === 'no' ||
      normalizedValue === 'false' ||
      normalizedValue === '0'
    ) {
      return FormConstants.BOOLEAN_TYPES.NO;
    }
  }

  if (value === true || value === 1) {
    return FormConstants.BOOLEAN_TYPES.YES;
  }

  return FormConstants.BOOLEAN_TYPES.NO;
};

const formatData = (
  value: FormattableValue,
  type: string | undefined,
  formatter?: string | undefined
): any => {
  if (type === FormConstants.CONFIG_FIELDS_TYPE.DATE) {
    if (typeof value !== 'boolean' && typeof value !== 'number') {
      return DateUtils.format(value, DateUtils.DEFAULT_DATE_FORMAT) || '';
    }
  } else if (type === FormConstants.CONFIG_FIELDS_TYPE.DATE_TIME) {
    if (typeof value !== 'boolean' && typeof value !== 'number') {
      return DateUtils.format(value, DateUtils.DATE_TIME_FORMAT) || '';
    }
  } else if (type === FormConstants.CONFIG_FIELDS_TYPE.BOOLEAN) {
    return formatBooleanValue(value);
  } else if (formatter === FormConstants.CONFIG_FIELDS_TYPE.CURRENCY) {
    return currencyFormatter(value) || '';
  } else if (formatter === FormConstants.CONFIG_FIELDS_TYPE.US_PHONE) {
    if (typeof value === 'string' || value === undefined) {
      return USPhoneNumberFormat(value) || '';
    }
  } else {
    return value;
  }
};

export const GetDisableCheckBox = (data: any): boolean => {
  if (
    data.row.Status === FormConstants.REPORTS_SCREENS.GENERATE_FAILURE ||
    data.row.Status === FormConstants.REPORTS_SCREENS.GENERATE_INITIATED ||
    data.row.Status === FormConstants.REPORTS_SCREENS.GENERATE_IN_PROGRESS ||
    data.row.Status === FormConstants.REPORTS_SCREENS.DELETE_SUCCESS
  ) {
    return false;
  }
  return true;
};

const AbnormalFlagValues = (): any => {
  return [
    'A',
    'AA',
    'ABN',
    'CRIT',
    'H',
    'HH',
    'HI',
    'HIGH',
    'I',
    'L',
    'LL',
    'LOW',
    'R',
    'S',
    'SYN-R',
    'SYN-S',
    '<LLOW',
    '>HHI',
    'Abnormal',
    'ABR',
    'ALERT',
    'CR',
    'FLT'
  ];
};

export const rowStyles = (data: any): string => {
  // If neither `IsAbnormal` nor `AbnormalFlag` exists, return early
  if (
    data?.row?.IsAbnormal === undefined &&
    data?.row?.AbnormalFlag === undefined
  ) {
    return 'pre-whitespace';
  }

  let abnormalFlagText = '';

  // Check `IsAbnormal`
  if (data?.row?.IsAbnormal !== undefined) {
    abnormalFlagText = data.row.IsAbnormal
      ? FormConstants.ABNORMAL_FLAG.TEXT
      : '';
  } else {
    // Fallback to `AbnormalFlag` check
    abnormalFlagText = AbnormalFlagValues()?.includes(
      data?.row?.AbnormalFlag?.toUpperCase()
    )
      ? FormConstants.ABNORMAL_FLAG.TEXT
      : '';
  }

  return `pre-whitespace ${abnormalFlagText}`.trim();
};

export default {formatData};

export const createJWT = async (payload: any, secret_key: any) => {
  try {
    const secret = new TextEncoder().encode(secret_key ?? ''); // Use a secure secret key
    // Generate the JTI (unique identifier) using the Web Crypto API
    const timeBuffer = new TextEncoder().encode(Date.now().toString());
    const hashBuffer = await crypto.subtle.digest('SHA-256', timeBuffer);
    const jti = Array.from(new Uint8Array(hashBuffer))
      .map(b => b.toString(16).padStart(2, '0'))
      .join('');
    const token = await new SignJWT(payload)
      .setJti(jti)
      .setProtectedHeader({alg: 'HS256'}) // Algorithm to use for signing
      .setIssuedAt()
      .setExpirationTime(Math.floor(Date.now() / 1000) + 300) // Token expires in 1 hour
      .setNotBefore(Math.floor(Date.now() / 1000))
      .sign(secret);
    return token;
  } catch (error) {
    console.error('Error creating JWT:', error);
  }
};
